export default __webpack_public_path__ + "static/media/status_blue_icon.40c3b6ff.svg";